<template>
	<div class="card md-elevation-4" style="width: auto; height: 100%; overflow-y: auto">
		<div style="display: flex">
			<div style="padding: 10px">
				<span class="tab"
					><strong>{{ expiringSubscriptions.length }}</strong>
					{{ $t("expiring-subscriptions-this-month").toLowerCase() }}</span
				>
			</div>
		</div>
		<div style="display: flex; margin-top: 5px">
			<v-calendar
				style="width: 415px; height: 300px; margin: auto"
				:attributes="attributes"
				@update:from-page="changeMonth"
				@dayclick="onDayClick"
			/>
		</div>

		<div style="padding: 10px; margin-top: 10px; display: flex">
			<div style="margin-top: auto; margin-bottom: 0; width: 100%">
				<div style="display: flex; font-size: 18px; width: 100%" v-if="expiringSubscriptions.length > 0">
					<span style="margin-left: auto; margin-right: 0"
						><strong>{{
							expiringSubscriptions.filter(el => moment(el.valid_until).isBefore(new Date())).length
						}}</strong>
						{{ $t("expired-subscriptions-this-month") }}</span
					>
				</div>
			</div>
		</div>

		<div v-if="clicked">
			<md-dialog :md-active="clicked" style="font-family: 'Montserrat', sans-serif">
				<div style="background-color: #eeeeee; width: 600px">
					<div class="dialog-header" style="min-width: 300px">
						<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">
							{{ $t("expiring subscription-on") + ": " }}
							<strong>{{ moment(day.id).format("D MMMM YYYY") }}</strong>
						</span>
						<div style="margin-left: auto; margin-right: 0">
							<md-button @click="clicked = false" class="md-icon-button" style="margin-right: -5px">
								<md-icon style="color: white">close</md-icon>
							</md-button>
						</div>
					</div>
					<div class="dialog-body">
						<div style="max-height: 500px; overflow-y: auto">
							<md-table v-model="dayElements" v-if="dayElements.length > 0">
								<md-table-row
									slot="md-table-row"
									slot-scope="{ item }"
									md-selectable="single"
									@click="e => goTo(item.organization.id)"
								>
									<md-table-cell :md-label="$t('organization')">
										{{ item.organization.name.String }}
									</md-table-cell>
									<md-table-cell :md-label="$t('subscription')">
										{{ item.subscription.name }}
									</md-table-cell>
								</md-table-row>
							</md-table>

							<div v-else>
								{{ $t("none-expiring-subscriptions-for-today ") }}
							</div>
						</div>
					</div>
				</div>
			</md-dialog>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
	name: "calendar",
	data() {
		return {
			array: [],
			dayElements: [],
			clicked: false,
			day: undefined
		}
	},
	computed: {
		...mapGetters({
			expiringSubscriptions: "dashboard/expiringSubscriptions"
		}),
		attributes() {
			this.count = 0
			var r = []
			this.expiringSubscriptions.forEach(item => {
				r.push({
					highlight: "yellow",
					dates: new Date(item.valid_until),
					customData: item,
					popover: {
						label: item.organization.name.String
					}
				})
			})
			r.push({
				key: "today",
				dates: new Date(),
				bar: true
			})

			return r
		}
	},
	methods: {
		...mapActions({
			doExpiringSubscriptions: "dashboard/doExpiringSubscriptions"
		}),
		goTo(id) {
			this.$router.replace({ path: "/users/schools/" + id })
		},
		onDayClick(day) {
			this.day = day
			var dayElements = []
			day.attributes.forEach(item => {
				if (item.customData) dayElements.push(item.customData)
			})

			this.dayElements = dayElements
			this.clicked = true
		},
		changeMonth: function (to) {
			this.doExpiringSubscriptions(to)
		}
	}
}
</script>
<style>
.vc-day-layer .vc-day-box-center-bottom {
	overflow: hidden !important;
}
</style>
<style scoped lang="scss">
@import "src/assets/scss/chart.scss";
.tab {
	font-size: 24px;
	margin-left: 5px;
	margin-right: 5px;
	&:hover {
		font-weight: 900;
		cursor: pointer;
	}
}

.bold {
	font-weight: 900;
}
</style>
